mutation RevokeAgent($agentRegistrationId: ID!) {
  revokeAgent(input: { agentRegistrationId: $agentRegistrationId }) {
    agentRegistration {
      id
      databaseId
      status
    }
    errors
  }
}